// extracted by mini-css-extract-plugin
export var checkbox = "_8u-0";
export var circle = "_8u-3";
export var horizontalContainer = "_8u-7";
export var sm = "_8u-5";
export var switch0 = "_8u-2";
export var switchDisabled = "_8u-8";
export var switchEnabled = "_8u-1";
export var textSwitchContainer = "_8u-9";
export var textSwitchOption = "_8u-a";
export var textSwitchOptionSelected = "_8u-b";
export var verticalContainer = "_8u-6";
export var xs = "_8u-4";